export default __webpack_public_path__ + "209306d26d115b9bb5d50436ba372993.svg";